
    <h2 mat-dialog-title style="color: #424242; font-family: Roboto; margin: 0; padding: 16px 24px; background: white;">
      Notes for {{ data.employeeName }}
    </h2>
    <div mat-dialog-content style="padding: 0 24px; background: white; max-height: 400px; overflow-y: auto;">
      <div *ngIf="data.notes.length === 0" style="color: #8a8a8a; padding: 20px 0; font-style: italic;">
        No notes for this week.
      </div>
      <div *ngFor="let n of data.notes" style="padding: 10px 0; border-bottom: 1px solid #eee;">
        <div style="display: flex; justify-content: space-between; align-items: flex-start;">
          <span style="color: #424242; flex: 1; word-break: break-word; font-size: 14px;">{{ n.note }}</span>
        </div>
        <div style="margin-top: 4px; display: flex; gap: 12px;">
          <span style="color: #8a8a8a; font-size: 12px;">{{ n.day?.substring(0,10) }}</span>
          <span *ngIf="n.created_by" style="color: #8a8a8a; font-size: 12px;">by {{ n.created_by }}</span>
          <span *ngIf="n.job_id" style="color: #477333; font-size: 12px;">{{ n.street_address }} - {{ n.customer_jobtype }}</span>
          <span *ngIf="!n.job_id" style="color: #8a8a8a; font-size: 12px; font-style: italic;">General</span>
        </div>
      </div>
    </div>
    <div mat-dialog-actions style="justify-content: flex-end; padding: 8px 24px; background: white;">
      <button mat-button (click)="dialogRef.close()" style="color: #666;">Close</button>
    </div>
  